// pictShow v.1.3.0 date 09.02.2026 
// -------------------------------------------------------------- 
// 21.01.2024 - исправлен относительный вызов API. Для корректной 
// работы с модулем SEFurl 
// 10.01.2026 - добавлена схема картинок листанием и переходы при 
// нажатии на маркер (dot)
// 09.02.2026 - оптимизирована загрузка: основная картинка показывается
// сразу, дополнительные загружаются асинхронно
//              все стили точек вынесены в CSS
// -------------------------------------------------------------- 
(function (window, document, undefined) {
    "use strict";

    var sitename = (location.protocol || 'https:') + '//' + (location.hostname || 'kommek.ru');

    // Declarations
    var objArbImgShow, objArbPictureMain, objArbPrlShow, objArbDscShow, objArbFonShow;
    var objArbPictSlider, objLeftArrow, objRightArrow, objScrollGallery;
    var objhiddenImg = [];
    
    // for a one-time initAP_config function call
    var initSet_pictShow = true;
    var scrSize, sclXY;
    
    // Initial script state
    var initPedW = 60;
    var initPedH = 80;
    var initDesH = 40;
    var slideIndex = 0;
    var touchStartX = 0;
    var pictArr = [];
    var jsonData = null;
    var isJsonLoading = false;
    var initialImageLoaded = false;
    var imagesLoadingCount = 0;

    function init_arbConfig() {
        objArbFonShow = document.getElementById("layer_arbFonShow");
        if (!objArbFonShow) {
            objArbFonShow = document.createElement("div");
            objArbFonShow.id = "layer_arbFonShow";
            objArbFonShow.className = "class_arbFonShow";
            objArbFonShow.style.display = "none";
            document.body.appendChild(objArbFonShow);
        }

        objArbPrlShow = document.getElementById("layer_arbPrlShow");
        if (!objArbPrlShow) {
            objArbPrlShow = document.createElement("div");
            objArbPrlShow.id = "layer_arbPrlShow";
            objArbPrlShow.className = "class_arbPrlShow";
            objArbPrlShow.style.display = "none";
            document.body.appendChild(objArbPrlShow);
        }

        objArbImgShow = document.getElementById("layer_arbImgShow");
        if (!objArbImgShow) {
            objArbImgShow = document.createElement("div");
            objArbImgShow.id = "layer_arbImgShow";
            objArbImgShow.className = "class_arbImgShow";
            objArbImgShow.style.display = "none";
            document.body.appendChild(objArbImgShow);
        }

        // Добавление изображений в slider
        objArbPictSlider = document.getElementById("id_arbPictSlider");
        if (!objArbPictSlider) {
            objArbPictSlider = document.createElement("div");
            objArbPictSlider.id = "arbPictSlider";
            objArbPictSlider.className = "class_arbPictSlider";
            objArbImgShow.appendChild(objArbPictSlider);
        }

        if (!objArbPictureMain) {
            objArbPictureMain = document.createElement("img");
            objArbPictureMain.className = "class_arbPicture";
            objArbPictureMain.setAttribute("alt", "");
            objArbPictSlider.appendChild(objArbPictureMain);
        }

        if (!objLeftArrow) {
            objLeftArrow = document.createElement("a");
            objLeftArrow.className = "class_leftArrow";
            objLeftArrow.style.display = "none";
            objArbImgShow.appendChild(objLeftArrow);
            var objLeftImage = document.createElement("div");
            objLeftImage.className = "class_leftImage";
            objLeftArrow.appendChild(objLeftImage);
        }

        if (!objRightArrow) {
            objRightArrow = document.createElement("a");
            objRightArrow.className = "class_rightArrow";
            objRightArrow.style.display = "none";
            objArbImgShow.appendChild(objRightArrow);
            var objRightImage = document.createElement("div");
            objRightImage.className = "class_rightImage";
            objRightArrow.appendChild(objRightImage);
        }

        if (!objScrollGallery) {
            objScrollGallery = document.createElement("div");
            objScrollGallery.className = "class_ScrollGallery";
            objScrollGallery.style.display = "none";
            objArbImgShow.appendChild(objScrollGallery);
        }

        objArbDscShow = document.getElementById("layer_arbDscShow");
        if (!objArbDscShow) {
            objArbDscShow = document.createElement("div");
            objArbDscShow.id = "layer_arbDscShow";
            objArbDscShow.className = "class_arbDscShow";
            objArbDscShow.style.display = "none";
            objArbImgShow.appendChild(objArbDscShow);
        }
    }

    function plusSlide() {
        setCurrentSlide(slideIndex + 1);
    }

    function minusSlide() {
        setCurrentSlide(slideIndex - 1);
    }

    function currentSlide(n) {
        setCurrentSlide(n);
    }

    function setCurrentSlide(n) {
        var slider = document.getElementsByClassName("class_arbPictSlider");
        if (!slider.length) return;
        
        var mySlides = slider[0].querySelectorAll('.class_arbPicture');
        if (!mySlides.length) return;
        
        var dots = document.getElementsByClassName("class_arbDot");

        // Корректируем индекс
        if (n < 1) {
            slideIndex = mySlides.length;
        } else if (n > mySlides.length) {
            slideIndex = 1;
        } else {
            slideIndex = n;
        }

        // Скрываем все слайды
        for (var i = 0; i < mySlides.length; i++) {
            mySlides[i].style.display = "none";
        }

        // Убираем активный класс у всех маркеров
        for (var i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(" class_active_slide", "");
            dots[i].setAttribute("aria-current", "false");
        }

        // Проверяем границы
        if (slideIndex < 1) {
            slideIndex = mySlides.length;
        }
        if (slideIndex > mySlides.length) {
            slideIndex = 1;
        }

        // Активируем соответствующий маркер
        if (dots[slideIndex - 1]) {
            mySlides[slideIndex - 1].style.display = "block";
            dots[slideIndex - 1].className += " class_active_slide";
            dots[slideIndex - 1].setAttribute("aria-current", "true");
        }
    }

    function handleTouchStart(e) {
        touchStartX = e.touches[0].clientX;
    }

    function handleTouchEnd(e) {
        if (!e.changedTouches || !e.changedTouches.length) return;
        
        const endX = e.changedTouches[0].clientX;
        const diff = touchStartX - endX;
        if (Math.abs(diff) > 50) {
            diff > 0 ? plusSlide() : minusSlide();
        }
    }

    function handleKeyNavigation(event) {
        switch (event.key) {
            case 'ArrowLeft':
                minusSlide();
                break;
            case 'ArrowRight':
                plusSlide();
                break;
            case 'Escape':
                arb_pictShow_off();
                break;
        }
    }

    function arb_pictShow_on(add_url, pictDesc, id_good) {
        if (id_good === undefined) {
            id_good = 0;
        }

        if (initSet_pictShow) {
            init_arbConfig();
            // Команда обеспечивает выполнение команды document.querySelectorAll.forEach для IE и старых версий
            if (typeof NodeList !== 'undefined' && NodeList.prototype && !NodeList.prototype.forEach) {
                NodeList.prototype.forEach = Array.prototype.forEach;
            }
            initSet_pictShow = false;
        }

        // Сбрасываем состояние
        resetState();
        
        scrSize = kmkCMSutil.screenSize();
        sclXY = kmkCMSutil.getScrollXY();
        
        // Сохраняем первую картинку
        pictArr = [add_url];
        
        // Создаем маркер для первой картинки
        createDotElement(0);
        
        // Начинаем загрузку основной картинки СРАЗУ
        startInitialImageLoad(add_url, pictDesc);
        
        // Асинхронно запрашиваем дополнительные картинки
        if (id_good && !isJsonLoading) {
            isJsonLoading = true;
            get_json_image(id_good);
        }
        
        // Устанавливаем обработчики событий
        setupEventHandlers();
        
        // Показываем интерфейс
        showInterface();
    }
    
    function resetState() {
        jsonData = null;
        pictArr = [];
        objhiddenImg = [];
        slideIndex = 0;
        isJsonLoading = false;
        initialImageLoaded = false;
        imagesLoadingCount = 0;
        
        // Очищаем старые элементы (кроме основного изображения)
        var additionalImages = document.querySelectorAll('.class_arbPicture:not(:first-child)');
        additionalImages.forEach(function(item) {
            item.remove();
        });
        
        var dots = document.querySelectorAll('.class_arbDot');
        dots.forEach(function(item) {
            item.remove();
        });
        
        objLeftArrow.style.display = "none";
        objRightArrow.style.display = "none";
        objScrollGallery.style.display = "none";
    }
    
    function startInitialImageLoad(url, pictDesc) {
        // Загружаем основное изображение
        objhiddenImg[0] = new Image();
        objhiddenImg[0].onload = function() {
            initialImageLoaded = true;
            getSizeAndShow(0);
        };
        objhiddenImg[0].onerror = function() {
            console.error('Ошибка загрузки основного изображения');
            arb_pictShow_off();
        };
        objhiddenImg[0].src = url + "?_=" + (new Date().getTime());
        objArbPictureMain.src = objhiddenImg[0].src;
        
        // Устанавливаем описание
        objArbDscShow.innerHTML = '<div class="class_arbPictDesc">' + (pictDesc || '') + '</div>';
        
        currentSlide(1);
    }
    
    function setupEventHandlers() {
        kmkCMSutil.addHandler(window, 'resize', reSizeAndShow);
        kmkCMSutil.addHandler(window, 'scroll', reSizeAndShow);
        kmkCMSutil.addHandler(window, 'orientationchange', orientationChange);
        kmkCMSutil.addHandler(window, 'keydown', handleKeyNavigation);
        
        kmkCMSutil.addHandler(objLeftArrow, 'click', minusSlide);
        kmkCMSutil.addHandler(objRightArrow, 'click', plusSlide);
        kmkCMSutil.addHandler(objArbImgShow, 'touchstart', handleTouchStart);
        kmkCMSutil.addHandler(objArbImgShow, 'touchend', handleTouchEnd);
        kmkCMSutil.addHandler(objArbPictSlider, 'click', arb_pictShow_off);
        kmkCMSutil.addHandler(objArbFonShow, 'click', arb_pictShow_off);
    }
    
    function showInterface() {
        document.body.classList.add('showPict-open');
        kmkCMSutil.setElementOpacity(objArbFonShow, 50);
        objArbFonShow.style.display = 'block';
        objArbDscShow.style.height = 0 + 'px';
        setObjPozition(objArbPrlShow, 'prl');
        objArbPrlShow.style.display = 'block';
    }

    function arb_pictShow_off() {
        // Удаляем все обработчики событий
        kmkCMSutil.removeHandler(window, 'resize', reSizeAndShow);
        kmkCMSutil.removeHandler(window, 'scroll', reSizeAndShow);
        kmkCMSutil.removeHandler(window, 'orientationchange', orientationChange);
        kmkCMSutil.removeHandler(window, 'keydown', handleKeyNavigation);
        
        kmkCMSutil.removeHandler(objLeftArrow, 'click', minusSlide);
        kmkCMSutil.removeHandler(objRightArrow, 'click', plusSlide);
        kmkCMSutil.removeHandler(objArbImgShow, 'touchstart', handleTouchStart);
        kmkCMSutil.removeHandler(objArbImgShow, 'touchend', handleTouchEnd);
        kmkCMSutil.removeHandler(objArbPictSlider, 'click', arb_pictShow_off);
        kmkCMSutil.removeHandler(objArbFonShow, 'click', arb_pictShow_off);
        
        // Сбрасываем состояние
        resetState();
        
        // Скрываем элементы интерфейса
        objArbDscShow.style.display = 'none';
        objArbImgShow.style.display = 'none';
        objArbPrlShow.style.display = 'none';
        objArbFonShow.style.display = 'none';
        
        document.body.classList.remove('showPict-open');
    }

    function setObjSize(obj, type, index) {
        if (typeof obj != "object" || index === undefined) {
            return 0;
        }
        
        if (!objhiddenImg[index]) return;

        if (type == "img") {
            var width = objhiddenImg[index].width || 0;
            var height = objhiddenImg[index].height || 0;
            var scrSizeW, scrSizeH, scaleW, scaleH;

            if (index === 0) {
                scrSizeW = scrSize.w;
                scrSizeH = scrSize.h;
            } else {
                scrSizeW = obj.offsetWidth || scrSize.w;
                scrSizeH = obj.offsetHeight || scrSize.h;
            }

            scaleW = (scrSizeW - initPedW) / width;
            scaleH = (scrSizeH - initPedH) / height;

            if (scaleW < 1 || scaleH < 1) {
                if (scaleW < scaleH) {
                    height = Math.floor(height * (scrSizeW - initPedW) / width);
                    width = scrSizeW - initPedW;
                } else {
                    width = Math.floor(width * (scrSizeH - initPedH) / height);
                    height = scrSizeH - initPedH;
                }
                objhiddenImg[index].width = width;
                objhiddenImg[index].height = height;
            }

            var pictures = document.getElementsByClassName("class_arbPicture");
            if (pictures[index]) {
                pictures[index].width = objhiddenImg[index].width;
                pictures[index].height = objhiddenImg[index].height;
            }
        }
    }

    function setObjPozition(obj, type, index) {
        if (typeof obj != "object") {
            return 0;
        }

        var left, top, width, height;
        
        if (index === undefined) {
            index = 0;
        }

        if (type == "fon") {
            left = sclXY.scrOfX;
            top = sclXY.scrOfY;
            width = scrSize.w;
            height = scrSize.h;
        } else if (type == "img") {
            width = (objhiddenImg[index] ? objhiddenImg[index].width : 0) + initPedW;
            height = (objhiddenImg[index] ? objhiddenImg[index].height : 0) + initPedH;
            left = scrSize.w / 2 + sclXY.scrOfX - width / 2;
            top = scrSize.h / 2 + sclXY.scrOfY - height / 2;
            if (left < 0) left = 0;
            if (top < 0) top = 0;
        } else if (type == "dsc") {
            left = 0;
            height = (objArbDscShow.style.height) ? (parseInt(objArbDscShow.style.height) || 0) : initDesH;
            top = (objhiddenImg[index] ? objhiddenImg[index].height : 0) + initPedH - height;
            width = (objhiddenImg[index] ? objhiddenImg[index].width : 0) + initPedW;
        } else if (type == "prl") {
            width = 100;
            height = 100;
            left = scrSize.w / 2 + sclXY.scrOfX - width / 2;
            top = scrSize.h / 2 + sclXY.scrOfY - height / 2;
            if (left < 0) left = 0;
            if (top < 0) top = 0;
        }

        setObjStyle(obj, { left, top, width, height });
    }

    function setObjStyle(obj, style) {
        if (typeof style.left == 'number') obj.style.left = style.left + 'px';
        if (typeof style.top == 'number') obj.style.top = style.top + 'px';
        if (typeof style.width == 'number') obj.style.width = style.width + 'px';
        if (typeof style.height == 'number') obj.style.height = style.height + 'px';
    }

    function reSizeAndShow() {
        scrSize = kmkCMSutil.screenSize();
        sclXY = kmkCMSutil.getScrollXY();
        
        if (objArbImgShow.style.display != 'none') setObjPozition(objArbImgShow, 'img');
        if (objArbDscShow.style.display != 'none') setObjPozition(objArbDscShow, 'dsc');
    }

    function orientationChange() {
        if (objArbImgShow.style.display != 'none') {
            objArbImgShow.removeAttribute('style');
        }
        scrSize = kmkCMSutil.screenSize();
        sclXY = kmkCMSutil.getScrollXY();
        
        if (objArbImgShow.style.display != 'none') {
            setObjSize(objArbImgShow, 'img');
            setObjPozition(objArbImgShow, 'img');
        }
        if (objArbDscShow.style.display != 'none') {
            setObjPozition(objArbDscShow, 'dsc');
        }
    }

    function getSizeAndShow(index) {
        setObjSize(objArbImgShow, 'img', index);
        
        if (index === 0) {
            setObjPozition(objArbImgShow, 'img', index);
            kmkCMSutil.setElementOpacity(objArbImgShow, 1);
            objArbPrlShow.style.display = 'none';
            objArbImgShow.style.display = 'block';
            kmkCMSutil.ShowSmoothOpacity(objArbImgShow, 100, 5);
            setSubscribtion(initDesH);
        }
    }
    
    function loadAdditionalImage(url, index) {
        if (!url) return;
        
        // Создаем точку для этого изображения (если еще не создана)
        if (!document.querySelector('.class_arbDot[data-index="' + index + '"]')) {
            createDotElement(index);
        }
        
        // Запускаем пульсацию для этой точки
        startDotPulse(index);
        imagesLoadingCount++;
        
        var img = new Image();
        img.onload = function() {
            objhiddenImg[index] = img;
            getSizeAndShow(index);
            // Останавливаем пульсацию после загрузки
            stopDotPulse(index);
            imagesLoadingCount--;
            
            // Если все изображения загружены, показываем навигацию
            if (imagesLoadingCount === 0 && jsonData && jsonData.images && jsonData.images.length > 0) {
                objLeftArrow.style.display = "block";
                objRightArrow.style.display = "block";
            }
        };
        img.onerror = function() {
            console.error('Ошибка загрузки дополнительного изображения:', url);
            // Останавливаем пульсацию при ошибке
            stopDotPulse(index);
            imagesLoadingCount--;
            
            // Если все изображения загружены (или возникли ошибки), показываем навигацию
            if (imagesLoadingCount === 0 && jsonData && jsonData.images && jsonData.images.length > 0) {
                objLeftArrow.style.display = "block";
                objRightArrow.style.display = "block";
            }
        };
        img.src = url + "?_=" + (new Date().getTime());
        
        var objPicture = document.createElement("img");
        objPicture.className = "class_arbPicture";
        objPicture.setAttribute("alt", "");
        objPicture.style.display = "none";
        objArbPictSlider.appendChild(objPicture);
        objPicture.src = img.src;
    }

    function setSubscribtion(size) {
        objArbDscShow.style.height = 0 + 'px';
        setObjPozition(objArbDscShow, 'dsc');
        objArbDscShow.style.overflow = 'hidden';
        kmkCMSutil.setElementOpacity(objArbDscShow, 60);
        objArbDscShow.style.display = 'block';
        kmkCMSutil.ShowSmoothHeight(objArbDscShow, size);
    }

    function createDotElement(index) {
        const dot = document.createElement("span");
        dot.className = "class_arbDot";
        dot.dataset.index = index;
        dot.setAttribute("role", "button");
        dot.setAttribute("aria-label", "Перейти к слайду " + (index + 1));
        dot.setAttribute("tabindex", "0");
        
        // Добавляем обработчик клика
        kmkCMSutil.addHandler(dot, 'click', function() {
            currentSlide(index + 1);
        });
        
        // Добавляем обработчик нажатия клавиши Enter/Space для доступности
        kmkCMSutil.addHandler(dot, 'keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                currentSlide(index + 1);
            }
        });
        
        objScrollGallery.appendChild(dot);
        return dot;
    }
    
    function startDotPulse(index) {
        var dot = document.querySelector('.class_arbDot[data-index="' + index + '"]');
        if (dot && !dot.classList.contains('class_loading_dot')) {
            dot.classList.add('class_loading_dot');
        }
    }
    
    function stopDotPulse(index) {
        var dot = document.querySelector('.class_arbDot[data-index="' + index + '"]');
        if (dot && dot.classList.contains('class_loading_dot')) {
            dot.classList.remove('class_loading_dot');
        }
    }
    
    function loadAdditionalImagesFromJson() {
        if (!jsonData || !jsonData.images || !jsonData.images.length) {
            isJsonLoading = false;
            return;
        }
        
        // Показываем галерею точек
        objScrollGallery.style.display = "block";
        
        // Сбрасываем счетчик загружаемых изображений
        imagesLoadingCount = 0;
        
        // Загружаем ВСЕ изображения одновременно
        jsonData.images.forEach(function(item, index) {
            if (item && item.url) {
                // Добавляем URL в массив
                var arrIndex = pictArr.length;
                pictArr.push(item.url);
                
                // Сразу загружаем изображение (точка создастся внутри loadAdditionalImage)
                loadAdditionalImage(item.url, arrIndex);
            }
        });
        
        // Если нет изображений для загрузки, показываем навигацию сразу
        if (imagesLoadingCount === 0 && jsonData.images.length > 0) {
            objLeftArrow.style.display = "block";
            objRightArrow.style.display = "block";
        }
        
        isJsonLoading = false;
    }

    function get_json_image(id_good) {
        if (!id_good) {
            isJsonLoading = false;
            return;
        }
        
        //var goodimgAPI = 'https://www.arnebia.ru/cgi-bin/api/mkt_get_goodimg.cgi';
        var goodimgAPI = sitename + '/cgi-bin/api/mkt_get_goodimg.cgi';
        var req = new HttpClient();
        
        req.get("POST", goodimgAPI, true, JSON.stringify({ "id_good": id_good }), function(response) {
            try {
                jsonData = JSON.parse(response);
                if (jsonData && jsonData.images) {
                    loadAdditionalImagesFromJson();
                } else {
                    isJsonLoading = false;
                }
            } catch (e) {
                console.error('Ошибка парсинга JSON:', e);
                jsonData = null;
                isJsonLoading = false;
            }
        }, function() {
            // Обработка ошибки запроса
            console.error('Ошибка при запросе дополнительных изображений');
            jsonData = null;
            isJsonLoading = false;
        });
    }

    var HttpClient = function() {
        this.get = function(method, aUrl, async, json, aCallback, errorCallback) {
            if (!method) method = "GET";
            if (!json) json = null;
            
            var anHttpRequest = createXMLHttpRequestObject();
            var timeoutId = setTimeout(function() {
                if (anHttpRequest.readyState !== 4) {
                    anHttpRequest.abort();
                    if (errorCallback) errorCallback();
                }
            }, 10000); // Таймаут 10 секунд
            
            anHttpRequest.onreadystatechange = function() {
                if (anHttpRequest.readyState == 4) {
                    clearTimeout(timeoutId);
                    if (anHttpRequest.status == 200) {
                        aCallback(anHttpRequest.responseText);
                    } else {
                        if (errorCallback) errorCallback();
                    }
                }
            };
            
            anHttpRequest.open(method, aUrl, async);
            anHttpRequest.setRequestHeader('Content-type', 'application/json; charset=utf-8');
            
            try {
                anHttpRequest.send(json);
            } catch (e) {
                clearTimeout(timeoutId);
                if (errorCallback) errorCallback();
            }
        };
    };

    var createXMLHttpRequestObject = function() {
        return window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject('Microsoft.XMLHTTP');
    };

    window.arb_pictShow_on = arb_pictShow_on;
})(window, document);
